export const addDays = (date: Date, days: number): Date => {
  const out = new Date(date);
  out.setDate(out.getDate() + days);
  return out;
};

export const addYears = (date: Date, years: number): Date => {
  const out = new Date(date);
  out.setFullYear(out.getFullYear() + years);
  return out;
};

export const getFirstOfNextMonth = (date: Date): Date => {
  const out = new Date(date);
  out.setMonth(out.getMonth() + 1);
  out.setDate(1);
  return out;
};

export const formatDateISO = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const parseDateISO = (iso: string): Date => new Date(`${iso}T00:00:00`);

export const formatDateDisplay = (date: Date, locale: string): string =>
  date.toLocaleDateString(locale, { month: 'short', day: 'numeric', year: 'numeric' });
